import { InteriorComponent, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';
import { PlannerConflictResolver } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
export class PlatsaConflictResolver extends PlannerConflictResolver {
    createConflict({ targetEntity, collidingEntity, entitiesToAddToCollidingEntityProductIds, collidingEntityAssembly }) {
        // Conflict when door is added to scene and interior blockes hinges
        if (targetEntity.hasComponent(InteriorComponent.id)) {
            if (collidingEntity.getComponent(ProductInfoComponent.id)?.productType ===
                ProductType.PLATSA_DOOR_FRONT ||
                collidingEntity.getComponent(ProductInfoComponent.id)?.productType ===
                    ProductType.PLATSA_SLIDING_DOOR_FRONT ||
                collidingEntity.getComponent(ProductInfoComponent.id)?.productType ===
                    ProductType.PLATSA_FRONT_LAYOUT ||
                collidingEntity.getComponent(ProductInfoComponent.id)?.productType ===
                    ProductType.PLATSA_HINGE_DOOR_ASM ||
                collidingEntity.getComponent(ProductInfoComponent.id)?.productType ===
                    ProductType.PLATSA_DRAWER_ASM) {
                const parent = targetEntity.getComponent(ComponentIds.CHILD_COMPONENT_ID)
                    ?.parent;
                if (!parent)
                    return null;
                // add product and autofill doors is resolved differently
                const addAction = this.addEntityToTargetAction({
                    entity: collidingEntityAssembly ? collidingEntityAssembly : collidingEntity,
                    parentEntityId: parent.id,
                    entitiesToAddToCollidingEntityProductIds
                });
                return {
                    entityId: targetEntity.id,
                    solve: [this.deleteAction(targetEntity.id), addAction],
                    messages: {
                        title: 'storageone.warningDoorHingeCollideWithInteriorsTitle',
                        info: 'storageone.collisionSheetInfoText',
                        yesButton: 'storageone.collisionSheetButtonAddLayout',
                        noButton: 'storageone.collisionSheetButtonDontAddLayout'
                    }
                };
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }
}
//# sourceMappingURL=platsaConflictResolver.js.map